import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { localize } from '../../util/Localizer'
import Icon from '@material-ui/core/Icon'
import { intlShape, FormattedMessage } from 'react-intl'
import ErrorMessage from '../../widgets/common/ErrorMessage'

// our component
import InputField from '../../controls/InputField'

import RBButton from '../../controls/RBButton'

class Username extends Component {
  constructor (props) {
    super(props)
    this.backToLogin = this.backToLogin.bind(this)
  }
  backToLogin (e) {
    e.preventDefault()
    this.context.router.history.push('/')
  }

  render () {
    const values = this.props.values
    return (
      <div className='usernameWidget'>
        <div>
          <h2><FormattedMessage id={'pages.ForgotPassword.Header'} /></h2>
          <p><FormattedMessage id={'pages.ForgotPassword.messageHeader'} /></p>
          <p><FormattedMessage id={'pages.ForgotPassword.message'} /></p>
        </div>
        <form autoComplete='off' id='login-form' onSubmit={this.props.checkUser} >
          <ErrorMessage error={this.props.error} />
          <br/>
          <InputField
            floatingLabelText={localize('pages.ForgotPassword.userName')}
            fullWidth
            className='userName'
            type='text'
            id='userName'
            autoComplete='off'
            errorText={values.noUserName ? values.noUserName : ''}
            onChange={this.props.handleInputChange}
            onBlur={this.props.handleInputChange} /><br />
          <div className='centered'>
            <RBButton
              type='submit'
              id='btnLogin'
              label={localize('pages.ForgotPassword.next')}
              variant='contained'
              primary
              fullWidth
              loading={this.props.loading}
              disabled={this.props.disableButton} />
          </div>
          <div>
            <RBButton
              id='backButton'
              label={localize('pages.ForgotPassword.backToLogin')}
              icon={<Icon color='primary'>chevron_left</Icon>}
              onClick={this.backToLogin}
              color
              styles={{ marginTop: 10 }}
            />
          </div>
        </form>
      </div>
    )
  }
}
Username.contextTypes = {
  intl: intlShape.isRequired,
  router: PropTypes.object
}

export default Username



// WEBPACK FOOTER //
// ./src/widgets/ForgotPassword/Username.js